/**
 * Mises en forme — logique pure.
 *
 * L'espace fine insécable (U+202F) tient « 12 500 F » d'un seul bloc. La
 * console HTML déclarait `NBSP` mais y mettait une espace ordinaire : le nom
 * promettait ce que le code ne faisait pas.
 */
const FINE = ' '

export function nombre(n: number | null | undefined): string {
  const v = Math.round(n ?? 0)
  return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, FINE)
}

export function fcfa(n: number | null | undefined): string {
  return `${nombre(n)}${FINE}F`
}

/** `25/09/2026` — chaîne vide si absente ou invalide. */
export function dateCourte(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
}

/** `25 sept. 2026` — comme l'affichage de la console HTML ; tiret long si absente. */
export function dateLongue(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' })
}

export function dateHeure(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  const h = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
  return `${dateCourte(iso)} à ${h}`
}

export function initiales(nom: string | null | undefined): string {
  const mots = String(nom ?? '?').trim().split(/\s+/).filter(Boolean)
  const i = mots.slice(0, 2).map((w) => w.charAt(0)).join('').toUpperCase()
  return i || '?'
}

/**
 * Couleur stable dérivée du nom : un tenant garde toujours la même pastille.
 * Ces sept teintes sont assez sombres pour porter du texte blanc (≥ 4,5:1).
 */
const PASTILLES = ['#0B6B52', '#2F5FC4', '#5B4BD1', '#9A5A0C', '#A03669', '#0A7087', '#5F6D16'] as const
export function couleurOrganisation(nom: string): string {
  let h = 0
  for (let i = 0; i < nom.length; i++) h = (h * 31 + nom.charCodeAt(i)) >>> 0
  return PASTILLES[h % PASTILLES.length] ?? '#0B6B52'
}

/** `2026-09` → `09/26`. */
export function moisCourt(mois: string): string {
  const [a, m] = mois.split('-')
  return `${m ?? '??'}/${(a ?? '').slice(2)}`
}
